import PropTypes from "prop-types";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { Drawer } from "app/components/ui/drawer/Drawer";
import { FormattedMessage } from "react-intl";
import Button, { BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import "./LastSearchDrawer.scss";
import LastSearchList from "app/features/SearchEngine/LastSearch/components/LastSearchList/LastSearchList";

const LastSearchDrawer = ({
	isOpen,
	onClose = () => {},
	onClearHistory = () => {},
	onRemoveSearch = () => {},
	onItemClick = () => {},
	lastSearches = [],
}) => {
	return (
		<Drawer.Root open={isOpen} onOpenChange={onClose}>
			<Drawer.Content className="last-search-drawer">
				<Drawer.Header className="last-search-drawer__header">
					<Typography
						variant={TYPOGRAPHY_VARIANTS.XL}
						isBold
						className="last-search-drawer__title"
						component="h2"
					>
						<FormattedMessage id="sdp.search.last.searches.drawer.title" />
					</Typography>

					{lastSearches?.length >= 1 && (
						<Button
							variant={BUTTON_VARIANTS.BORDERLESS}
							onClick={onClearHistory}
							data-testid="last-search-remove-button"
							className="last-search-drawer__clear-button"
						>
							<Typography
								variant={TYPOGRAPHY_VARIANTS.REGULAR}
								isBold
								component="span"
							>
								<FormattedMessage id="sdp.search.last.searches.clear.button.label" />
							</Typography>
						</Button>
					)}
				</Drawer.Header>

				<Drawer.Body className="last-search-drawer__body">
					<LastSearchList
						items={lastSearches}
						onRemoveSearch={onRemoveSearch}
						onItemClick={onItemClick}
					/>
				</Drawer.Body>
			</Drawer.Content>
		</Drawer.Root>
	);
};

LastSearchDrawer.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func,
	onClearHistory: PropTypes.func,
	onRemoveSearch: PropTypes.func,
	onItemClick: PropTypes.func,
	lastSearches: PropTypes.array,
};

export default LastSearchDrawer;
